export const STATIC_HOST_SECURE = 'https://image.intertoys.nl';